// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5d9d8b54","498":"71d2491c","598":"76a52c33"}[chunkId] + ".chunk.js";
};